import { render, staticRenderFns } from "./select-hotel-feature.vue?vue&type=template&id=7c162556"
import script from "./select-hotel-feature.vue?vue&type=script&lang=ts"
export * from "./select-hotel-feature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports